"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GeocodingProvider {
    constructor(name) {
        this.name = name;
    }
    forwardAsync(query) {
        const self = this;
        return new Promise((resolve, reject) => {
            self.forward(query, resolve);
        });
    }
    reverseAsync(query) {
        const self = this;
        return new Promise((resolve, reject) => {
            self.forward(query, resolve);
        });
    }
}
exports.default = GeocodingProvider;
